// Imports
import { useStateValue } from '../../_global/jsx/store';
import { ReactBarChart } from '../../ReactBarChart/jsx/component.jsx';
import { dangerousHTML } from 'src/lib/utils.js';
import { ReactColourKey } from '../../ReactColourKey/jsx/component.jsx';
import { ReactDetailedReport } from 'src/modules/ReactDetailedReport/jsx/component.jsx';

import {ReactDetailedAssessmentHub} from '../../ReactDetailedAssessmentHub/jsx/component.jsx'


// Stateful components

export const ReactDetailedOverview = (props) => {
    const [{ globalText, userData, controlData, questionData, questionSectionData, modalData }, dispatch] = useStateValue();
    const overviewData = controlData.currentItem;


    // This is the same function as in ReactDetailedReport, line 309. We should move some of these functions out into a helper file
    const getUserResultsOfDetailedAssessmentSection = (sectionId) => {
        let detailSection = questionSectionData[sectionId];
        let sectionQuestions = detailSection.children;

        if (typeof(sectionQuestions) !== 'undefined') {
            
            let totalScore = 0;

            //filter out the questions that are linked to rapid assessment questions in which the user has selected Yes(0);
            var filteredQuestions = sectionQuestions.filter((question) =>{
                if (question.qType === 'rangeSlider') {
                    //check if the this question has a linked rapid assessment question
                    //linkedRapidQuestion
                    if(typeof(question.linkedRapidQuestion) !== "undefined"){
                        if(question.linkedRapidQuestion !== ""){
                            var userResponse = userData.questionResponses[question.linkedRapidQuestion]; 
                            //if the user has answered yes(0) - then do not show this question
                            if(userResponse === 0){
                                return false;
                            }
                        }
                    }
                    return true;
                }
                return false;
            });     

            //let noOfQuestions = sectionQuestions.length;
            let noOfQuestions = filteredQuestions.length;
            
            filteredQuestions.forEach(question => {
                let assetID = question.assetID;
                const maxValue = question.rangeSliderMax ? question.rangeSliderMax - 1 : 4;

                // A bottom slider value of '1' should actually be worth 0
                let score = userData.questionResponses[assetID] - 1;
                let percentageScore = score / maxValue * 100;

                if (score < 0) { // Discount disabled questions
                    noOfQuestions--;
                } else {
                    totalScore += percentageScore;
                }
            });

            let averageScore = Math.ceil(totalScore / noOfQuestions);

            return averageScore;
        }
        
        return 'N/A';
    }

    // Click handler for opening the progress report modal
    const reportModalHandler = (sectionId, event) => {
        event.preventDefault();

        let modalContent = <ReactDetailedReport sectionId={sectionId} />;

        dispatch({
            type: 'showProgressReportModal',
            value: { modalContent: modalContent}
        });
    }


    const buildOverviewCharts = () => {
        let detailedAssessmentSection = Object.values(questionSectionData).filter((item) => {
           // var rapidSectionPercentage = getUserResultsOfRapidQuestionSection(item.linkedSection);
            //console.log(rapidSectionPercentage);
            return item.assessmentType == "detailed";
        })
        
        //filter out all the detailed sections that have 100% from the Rapid Assessment Section
        let filteredDetailedSection = detailedAssessmentSection.filter((item) => {
             var rapidSectionPercentage = getUserResultsOfRapidQuestionSection(item.linkedSection);
              //console.log(rapidSectionPercentage);
            return rapidSectionPercentage !== 100;
        })
        //get the linked Rapid Section and whether its 100%
        //linkedSection

        //if all the sections have been filtered out, then show a messsage
        if(filteredDetailedSection.length === 0){
            return <> <div dangerouslySetInnerHTML={dangerousHTML(globalText.detailedAssessmentOverviewRapid100All)}></div></>;
        }

        // Loop over all sections and display progress
        let allDASections =  filteredDetailedSection.map((section, key) => {
            let sectionId = section.assetID;
            let sectionUserScore = getUserResultsOfDetailedAssessmentSection(sectionId);
            let sectionStarted = (sectionUserScore === 'N/A' || isNaN(sectionUserScore)) ? false : true;
            let sectionNotStarted = sectionStarted === false ? 'br-app-over__incomplete' : '';
        
            return(
                <div key={key} className={`br-app-overview__section ${sectionNotStarted}`}>
                    <div className="br-app-overview__header">
                        <h3 className="br-app-overview__header__heading">{section.headerText}</h3>
                        { sectionStarted ? <a href="#" className="br-app-overview__open-report" onClick={(event) => {reportModalHandler(sectionId, event)}}>{globalText.overviewReportLabel}</a> : '' }
                    </div>
                    <ReactBarChart userScore={sectionUserScore} industryScore={section.industryScore} />
                </div>
            )
        })
        //add the colour key abouve the sections
        allDASections.unshift(<ReactColourKey key="reactcolourKeyComponent" />);

        return allDASections;
    }


    // Get 
    const getRapidQsectionFromAssetID = (rQsectionAssetID) => {
        //filter out all but the rapid sections
        let rapidQsections = Object.values(questionSectionData).filter(
            (item) => {
                return item.assessmentType == "rapid";
            }
        )
        //find the rapid section by assetId from the passed parameter
        let rapidSection = rapidQsections.find((item) =>{
            return item.assetID == rQsectionAssetID;
        })

        return rapidSection;
    }

    // Get percentage score for the linked Rapid Assessment section
    const getUserResultsOfRapidQuestionSection = (rQsectionAssetID) => {
        let rapidQsection = getRapidQsectionFromAssetID(rQsectionAssetID);
        
        let sectionQuestions = rapidQsection.children;       
        let noOfQuestions = sectionQuestions.length;
        let totalScore = 0;

        
        sectionQuestions.forEach(question => {
            let rQassetID = question.assetID;
            let score = userData.questionResponses[rQassetID];

            if (score === 0) {
                totalScore++;
            } else if (score === 3) {
                noOfQuestions--;
            }
        });

        let percentage = totalScore / noOfQuestions * 100;
       // console.log("totalScore for section:",rapidQsection.navName ,totalScore);
        //console.log("percentage score for section:",rapidQsection.navName ,percentage);

        return percentage;
    }






    return (
        <div className="br-app-overview">
                      
            { buildOverviewCharts() }
        </div>
    );

};
